import { createReducer, on } from '@ngrx/store';
import { CustomNewsCard } from '@src/app/core/types/news-card.type';
import { NewsActions } from './news.actions';

export const initialState: CustomNewsCard = {
  id: '',
  image: '',
  date: new Date(),
  title: '',
  category: '',
  content: '',
};

export const newsReducer = createReducer(
  initialState,
  on(NewsActions.setSelectedNews, (state, { news }) => ({ ...news })),
);
